export function formatWeight(weight: any): string {
  let weightNumber;
  if (isNaN(weight)) {
    if (weight.includes('lbs')) {
      weightNumber = Number(weight.replace('lbs', ''));
    } else if (weight.includes('lb')) {
      weightNumber = Number(weight.replace('lb', ''));
    } else {
      return weight;
    }
  } else {
    weightNumber = weight;
  }

  const formatterWeigth = `${Number(weightNumber).toLocaleString()} lbs`;
  return formatterWeigth;
}

export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function toSentenceCase(str: string) {
  return str.charAt(0).toUpperCase() + str.substr(1);
}
